interface ConversationStartersProps {
  questions: string[];
  onSelect: (question: string) => void;
}

export function ConversationStarters({ questions, onSelect }: ConversationStartersProps) {
  if (questions.length === 0) return null;

  return (
    <div class="flex-1 flex flex-col items-center justify-center gap-2 px-2">
      {questions.map((q) => (
        <button
          key={q}
          onClick={() => onSelect(q)}
          class="pill-btn w-full text-sm text-center px-4 py-2.5 rounded-xl border transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
        >
          {q}
        </button>
      ))}
    </div>
  );
}
